import { render, staticRenderFns } from "./SpaceUploadDialog.vue?vue&type=template&id=56620a34&scoped=true"
import script from "./SpaceUploadDialog.vue?vue&type=script&lang=js"
export * from "./SpaceUploadDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56620a34",
  null
  
)

export default component.exports